// biome-ignore-all lint/security/noDangerouslySetInnerHtml: help text is admin-authored and rendered through richTextDisplayHtml (sanitizeRichText whitelist), same as HelpButton.
// =============================================================================
// HelpModalHost — renders the shared help modal driven by services/helpModal
// =============================================================================
// Mounted ONCE at the app root (main.jsx), like DialogHost. When showHelp(key) is
// called (from a Resources page's `#help=` link), this fetches the help text and
// shows it via ModalBackdrop + richTextDisplayHtml — the same rendering the (?)
// HelpButton uses. Read-only. HelpButton itself is untouched (keeps its own modal).
// =============================================================================

import React from "react";
import { getHelpText } from "../../data/helpContent";
import { helpLabel } from "../../services/helpCatalog";
import { closeHelp, subscribeHelp } from "../../services/helpModal";
import { richTextDisplayHtml } from "../../services/richText";
import { ModalBackdrop } from "../form/FormUI.jsx";

export function HelpModalHost() {
  const [key, setKey] = React.useState(null);
  // null = still loading; "" = no content; string = the help HTML.
  const [text, setText] = React.useState(null);

  React.useEffect(function () {
    return subscribeHelp(function (k) {
      setKey(k);
    });
  }, []);

  React.useEffect(
    function () {
      if (!key) {
        setText(null);
        return;
      }
      let live = true;
      setText(null);
      getHelpText(key).then(function (content) {
        if (live) setText(content?.trim() ? content : "");
      });
      return function () {
        live = false;
      };
    },
    [key]
  );

  if (!key) return null;
  return (
    <ModalBackdrop
      portal
      onClose={closeHelp}
      contentStyle={{
        background: "white",
        borderRadius: 12,
        padding: 28,
        width: "calc(100vw - 40px)",
        maxWidth: 560,
        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        maxHeight: "80vh",
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
        textAlign: "left",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <strong style={{ color: "#00695C", fontSize: 16 }}>{helpLabel(key)}</strong>
        <button
          type="button"
          onClick={closeHelp}
          style={{
            background: "none",
            border: "none",
            fontSize: 20,
            cursor: "pointer",
            color: "#666",
          }}
        >
          x
        </button>
      </div>
      <div style={{ textAlign: "left" }}>
        {text === null ? (
          <p style={{ color: "#666", fontSize: 14 }}>Loading…</p>
        ) : text ? (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              color: "#333",
              fontSize: 14,
              lineHeight: 1.7,
              margin: "0 0 12px",
              maxWidth: "100%",
              textAlign: "left",
            }}
            dangerouslySetInnerHTML={{ __html: richTextDisplayHtml(text) }}
          />
        ) : (
          <p style={{ color: "#333", fontSize: 14, lineHeight: 1.7, margin: "0 0 12px" }}>
            No help content yet.
          </p>
        )}
      </div>
    </ModalBackdrop>
  );
}
